import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

import {
  CASE_BY_ID,
  CASE_BY_ID_RESPONSE,
  CASE_BY_ID_SHORT_vars,
} from "graphql/query/caseByIdShort";
import { DocumentTypeEnum } from "enums";

export const useUploadDocumentsMembers = (caseAccessId: string) => {
  const { t } = useTranslation();
  const { data, error, loading } = useQuery<
    CASE_BY_ID_RESPONSE,
    CASE_BY_ID_SHORT_vars
  >(CASE_BY_ID, {
    variables: { caseAccessId: caseAccessId },
  });

  const transformedHouseholdMembers = useMemo(() => {
    const applicant = data?.caseById?.mnsureEnrollment?.applicant;
    const fullName = [applicant?.firstName, applicant?.lastName]
      .filter(Boolean)
      .join(" ");

    return [
      {
        caseAccessId,
        householdMemberId: null,
        name: fullName,
        documentsList: [
          {
            documentDescription: t(
              "upload_documents_description_main_applicant",
            ),
            documentUploadType: DocumentTypeEnum.GOVERNMENT_ID,
            file: undefined,
          },
        ],
      },
    ];
  }, [data, caseAccessId, t]);

  return {
    loading,
    error,
    data,
    transformedHouseholdMembers,
  };
};
